var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFallback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M376 192v8a4 4 0 0 1-4 4h-12v6a6 6 0 0 1-6 6H158a6 6 0 0 1-6-6v-6h-12a4 4 0 0 1-4-4v-8a4 4 0 0 1 2.5-3.7l116-44a4 4 0 0 1 3 0l116 44a4 4 0 0 1 2.5 3.7zm-12 152H148a12 12 0 0 0-12 12v8a4 4 0 0 0 4 4h232a4 4 0 0 0 4-4v-8a12 12 0 0 0-12-12zM176 224v96h-18a6 6 0 0 0-6 6v10h208v-10a6 6 0 0 0-6-6h-18v-96h-32v96h-32v-96h-32v96h-32v-96h-32z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallback);
export default __webpack_public_path__ + "static/media/Fallback.2b8fb1df7284f87ba6d4a420296e37e1.svg";
export { ForwardRef as ReactComponent };